(function () {
    'use strict';

    angular
        .module('app.community')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
            {
                state: 'community',
                config: {
                    abstract: true,
                    url: '/community',
                    template: '<ui-view/>',
                   
                    resolve: {
                        authenticationRequired: ['userService', function (userService) {
                            userService.isAuthenticatedThrowError();
                        }]
                    }
                }
            },
            {
                state: 'community.topics',
                config: {
                    url: '/topics',
                    templateUrl: 'app/community/topicsList.html?v=' + opsIncludeVersion,
                    controller: 'TopicsListController',
                    controllerAs: 'vm',
                    title: 'Topics',
                    settings: {
                        authMode: 1,
                        requireOps: true,
                        nav: 1000,
                        content: '<i class="fa fa-commenting-o "></i> <span class="leftNavText">Community</span>'
                    }
                }
            },
            {
                state: 'community.topicdetails',
                config: {
                    url: '/topicdetails/:id',
                    templateUrl: 'app/community/topicDetails.html?v=' + opsIncludeVersion,
                    controller: 'TopicDetailsController',
                    controllerAs: 'vm',
                    title: 'Topic Details'


                }
            }
            , {
                state: 'community.topicdisplay',
                config: {
                    url: '/topicdisplay/:id',
                    templateUrl: 'app/community/topicDisplay.html?v=' + opsIncludeVersion,
                    controller: 'TopicDisplayController',
                    controllerAs: 'vm',
                    title: 'OPs Community Conversation'
                }
            }
        ];
    }
})();
